const FindInteneryDetails = (data) => {
  const allMonthVariations = [
    "jan",
    "january",
    "janury",
    "januray",
    "feb",
    "february",
    "febuary",
    "febary",
    "febry",
    "mar",
    "march",
    "marhc",
    "apr",
    "april",
    "arpil",
    "may",
    "mya",
    "jun",
    "june",
    "juen",
    "jne",
    "jul",
    "july",
    "jly",
    "aug",
    "august",
    "agust",
    "sep",
    "sept",
    "september",
    "setember",
    "sebt",
    "oct",
    "october",
    "octobar",
    "nov",
    "november",
    "novembar",
    "dec",
    "december",
    "decembar",
  ];
  // find Namding.
  const getName = (str) => {
    let arrRows = str?.split("\n");
    let lineArr = [];
    arrRows?.forEach((el) => {
      if (el?.trim("")?.[1] == ".") {
        let arr = el?.trim("")?.split(" ");
        let valRes = "";
        arr?.forEach((val) => {
          if (val) {
            if (!val?.includes(".")) {
              valRes += " " + val;
              lineArr[lineArr.length - 1] = valRes;
            } else {
              valRes = !parseInt(val[2])
                ? val?.slice(2, val.length)
                : val?.slice(3, val.length);
              lineArr.push(valRes);
            }
          }
        });
      }
    });
    const arrofname = [];
    const formatted = lineArr.map((name) => {
      const obj = {};
      let str = name;
      const child = str.match(/\((.*?)\)/)?.[0];
      if (child) {
        obj.child = child;
        str = str.replace(/\(.*?\)/, "").trim();
      }
      const title = str.match(/\b(MR|MRS)\b/)?.[0];
      if (title) {
        obj.title = title;
        str = str.replace(/\b(MR|MRS)\b/g, "").trim();
      }
      if (str.includes("/")) {
        const devname = str.split("/");
        obj.first_name = devname?.[1];
        obj.last_name = devname?.[0];
      } else {
        const devname = str.split(" ");
        obj.first_name = devname.slice(0, -1).join(" ");
        obj.last_name = devname?.[devname?.length - 1];
      }
      arrofname.push(obj);
    });
    return arrofname;
  };
  const nameclient = getName(data);

  // Airlined code.
  const Airline = (str) => {
    const raw = str.match(/\b[A-Z0-9]{2,10}\b/g) || [];
    const codes = raw.filter((c) => /[A-Z]/.test(c));

    if (codes.length > 0) {
      const value = codes[0]?.slice(0, 2);
      return value;
    }
    const parts = str.trim().split(/\s+/);
    const value = parts[0]?.slice(0, 2);
    return value || "";
  };

  // flight number.
  const findflighteNo = (str) => {
    const string = str
      .replace(/\b\d{1,2}[A-Z]{3}\b/i, "")
      .replace(/\s{2,}/g, " ")
      .trim();
    const match = string.match(/\b[A-Z]{2}\s?(\d{1,4}[A-Z]?)\b/);
    return match ? match[1] : "";
  };

  // fight routes
  const findRoute = (str) => {
    let string = str
      .replace(/\b\d{1,2}[A-Z]{3}\b/i, "")
      .replace(/\s{2,}/g, " ")
      .trim();
    string = str
      .replace(/\b[A-Z]{6}\b/, "")
      .replace(/\s{2,}/g, " ")
      .trim();
    const match = str.match(/\b[A-Z]{6}\b/);
    const half = match?.[0]?.length / 2;
    const firstHalf = match?.[0]?.slice(0, half);
    const secondHalf = match?.[0]?.slice(half);
    return match ? { to: secondHalf, from: firstHalf } : {};
  };

  function extractTimeEndings(text) {
    const timePattern = /\b(?:\d{3,4}[AP]){1,2}\b/g;
    const matches = text.match(timePattern);
    if (matches) {
      if (matches?.length !== 2) {
        const time = matches?.[0].match(/\d{3,4}[AP]/g) || [];
        return { arr_time: time[1], dep_time: time[0] };
      }
      return { arr_time: matches[1], dep_time: matches[0] };
    }
  }

  const extractFlightSegments = (input) => {
    const regex = /(?:^|\n)\s*(\d) ([\s\S]*?)(?=(?:\n\s*\d |\n*$))/g;
    const matches = [];
    let match;
    while ((match = regex.exec(input)) !== null) {
      matches.push(match[0].trim());
    }
    return matches;
  };

  const segments = extractFlightSegments(data);
  const dataObj = {};

  dataObj["passengers"] = nameclient;
  dataObj["flights"] = [];
  segments.forEach((oneline) => {
    const sr = oneline.split(/\s+/);
    let obj = {};
    const airline = Airline(oneline);
    const flight_no = findflighteNo(oneline);
    const routes = findRoute(oneline);
    const time = extractTimeEndings(oneline);
    sr.forEach((el, index) => {
      // date
      const matchdate = allMonthVariations.find((month) =>
        el.toLowerCase().includes(month)
      );
      if (matchdate) {
        if (obj.date) {
          obj.end_date = el;
        } else {
          obj.date = el;
        }
      }
      // time
      const timematch = /^\d{4}$/.test(el);
      if (timematch) {
        if (obj.dep_time) {
          obj.arr_time = el;
        } else {
          obj.dep_time = el;
        }
      }
    });
    if (!(obj?.arr_time || obj?.dep_time)) {
      obj = { ...obj, ...time };
    }
    dataObj.flights.push({
      airline: airline,
      ...obj,
      flight_no: flight_no,
      ...routes,
    });
    obj = {};
  });
  return dataObj;
};

export default FindInteneryDetails;
